import { SPLIT_CHAR } from './constants';
import type { ENTITY_TYPES } from './constants';

/**
 * Builds the canonical string id for an entity within a body.
 *
 * Lives in its own module rather than in `loaders/step/utils` because several
 * eagerly-loaded app modules (the vector editors) need only this one string join,
 * while that utils module reaches three.js — importing it from there put the whole
 * engine in the app's initial chunk. Import this module directly
 * (`@frontend/partviewer/src/entity-name`); do not re-export it from `step/utils`.
 * A package self-import re-export there fails webpack's harmony export analysis.
 */
export const constructEntityName = (
  ...args: [string, ENTITY_TYPES, ...(number | string)[]] //[ hostBodyId, entityType, (entity index or id)? ]
): string => args.join(SPLIT_CHAR);
